export default "__VITE_PUBLIC_ASSET__8de49aee__"